export type TeamTreeRow = { id: string; name: string; prefix: string };

// member-picker 팝업/iframe 컴포넌트 전용 team 트리 구성 로직(2026-08-03, 멤버 피커 팝업
// 플랜에서 분리 — 원래 apps/schoolbell-e/web/src/app/shared/team-tree.util.ts였고 org-detail
// 계열과도 공유했으나, org-detail 쪽은 2026-08-18에 중첩 트리 버전
// (@sbe-spinoff-client/schoolbell-org-team-tree의 buildTeamTreeNodes/TeamTreeNode)으로 이관돼
// 지금은 이 flat+prefix 버전(buildTeamTree/TeamTreeRow)의 유일한 소비처가 member-picker뿐이라
// 2026-08-20 이 lib으로 함께 이동). Orval 생성 모델의 OrgTeamDto 대신 실제로 쓰는 필드
// (id/name/parentPath)만 구조적 타입으로 받는다.
//
// parentPath는 org·자기 자신을 뺀 중간 조상 team 체인 `{ id }[]`(루트→직계 부모)다. 직속 부모 기준으로
// 되짚어 `tree` 명령어 스타일 접두사(├─/└─/│)를 계산한다. id/parentPath[].id 둘 다 "{shard}:{id}"
// 포맷이라(2026-08-18 org-team-manager-role-alignment 플랜) 별도 변환 없이 그대로 키로 쓴다.
export interface TeamTreeSourceItem {
  readonly id: string;
  readonly name: string;
  readonly parentPath: readonly { readonly id: string }[];
}

export function buildTeamTree(items: readonly TeamTreeSourceItem[]): TeamTreeRow[] {
  const childrenByParentTeamId = new Map<string, TeamTreeSourceItem[]>();
  const topLevel: TeamTreeSourceItem[] = [];
  for (const item of items) {
    const directParent = item.parentPath.at(-1);
    if (!directParent) {
      topLevel.push(item);
      continue;
    }
    const parentTeamId = directParent.id;
    const list = childrenByParentTeamId.get(parentTeamId) ?? [];
    list.push(item);
    childrenByParentTeamId.set(parentTeamId, list);
  }

  const rows: TeamTreeRow[] = [];
  const walk = (item: TeamTreeSourceItem, prefix: string, isLast: boolean): void => {
    rows.push({ id: item.id, name: item.name, prefix: `${prefix}${isLast ? '└─ ' : '├─ '}` });
    const childPrefix = `${prefix}${isLast ? '   ' : '│  '}`;
    const children = childrenByParentTeamId.get(item.id) ?? [];
    children.forEach((child, index) => walk(child, childPrefix, index === children.length - 1));
  };
  topLevel.forEach((item, index) => walk(item, '', index === topLevel.length - 1));
  return rows;
}
